import { CustomerListUrlSortField } from "@saleor/customers/urls";
import { UserSortField } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(
  sort: CustomerListUrlSortField
): UserSortField {
  switch (sort) {
    case CustomerListUrlSortField.email:
      return UserSortField.EMAIL;
    case CustomerListUrlSortField.name:
      // return UserSortField.DATE_JOINED;
      return undefined;
    case CustomerListUrlSortField.orders:
      return UserSortField.ORDER_COUNT;
    case CustomerListUrlSortField.dateJoined:
      return UserSortField.DATE_JOINED;
    default:
      return undefined;
  }
}

export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
